import React, { useEffect } from 'react'
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import { Workshop } from '../Workshops';
import Gadget from '../Gadget'
import Dots from '../Dots';
import labels from '../Mentors/const';
import useLabels from '../../utils/useLabels';

import * as s from './style.module.css';
import { LazyLoadImage } from "react-lazy-load-image-component"

export default function MentorsFull(mentors, { lang }) {
  const t = useLabels(labels, lang);
  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    if (typeof location != 'undefined') {
     // eslint-disable-next-line no-restricted-globals
     location.hash = location.hash;
    }
  }, [])

  if (mentors.mentors && mentors.mentors.mentors.length > 0) {
    t.title = mentors.mentors.title;
    t.mentors = mentors.mentors.mentors;
    t.prelegents = mentors.mentors.prelegents;
    t.prelegentsTitle = mentors.mentors.prelegentsTitle;
  }

  return (
    <div className={s.root}>
      <Container>
        <div className={s.header}>
          <h2>{t.title}</h2>
          <div className={s.divider} />
        </div>
        
        <Row sm={1} md={2}>
        {t.mentors && t.mentors.map((mentor) => (

          printMentors(mentor)

        ))}
        </Row>

        <div className={s.header}>
          <h2>{t.prelegentsTitle}</h2>
          <div className={s.divider} />
        </div>

        <Row sm={1} md={2}>
        {t.prelegents && t.prelegents.map((prelegent) => (

          printMentors(prelegent)

        ))}
        </Row>
      </Container>
    </div >
  )
}

function printMentors(mentor) {

  let show = mentor.description ? true : false;

  // <Workshop {...mentor} workshop={mentor.name} />

  if (!show) return null;
  let hide = false;

  if (mentor.name === " " || mentor.linkedin === " ") {
     hide = true;
  }

  return (

    
      <div className={s.mentor} id={mentor.id}>
        <div className={s.name}>{mentor.name}</div>
        <div className="d-flex flex-row align-items-center mt-4">
        <div className={s.imageWrapper}>
          {/*<MentorImage css={s.mentorImg} filename={mentor.image} />*/}
          <LazyLoadImage effect="blur"  alt="mentor zdjecie" src={mentor.image}/>
          <div className={s.dotsWrapper}>
            <Dots x={5} y={5} />
          </div>
        </div>
        <div>
          <div className={s.title}>
            {mentor.title}
          </div>
        </div>
          { !hide &&
          <div className={s.linkedin}>
            <a href={mentor.linkedin} target="_blank">
              <img alt="logo social mediów mentora" src={require('./images/linkedin.svg').default} />
            </a>
          </div>
          }
      </div>


      <div className={s.divider} /> 
      <p className={s.text} dangerouslySetInnerHTML={{ __html: mentor.description }} />


      <div className={s.border} />
        

      </div>

  )

}